import type { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import type { AuthState } from '../core/ngrx/state/auth.state';
import { initialAuthState } from '../core/ngrx/state/auth.state';
import * as auth from '../core/ngrx/reducer/auth.reducer';
import * as user from '../core/ngrx/reducer/user.reducer';
import * as twoFactorAuth from '../core/ngrx/reducer/two-factor-auth.reducer';
import * as configVersion from '../core/ngrx/reducer/config-version.reducer';

import { LogoutAction } from '../core/ngrx/action/auth.action';
import type { TwoFactorAuthState } from '../core/ngrx/state/two-factor-auth';
import { initialTwoFactorAuthState } from '../core/ngrx/state/two-factor-auth';
import type { UserState } from '../core/ngrx/state/user.state';
import { initialUserState } from '../core/ngrx/state/user.state';
import type { ConfigVersionState } from '../core/ngrx/state/config-version.state';
import { initialConfigVersionState } from '../core/ngrx/state/config-version.state';

export interface ApplicationState {
  auth: AuthState;
  user: UserState;
  twoFactorAuth: TwoFactorAuthState;
  configVersion: ConfigVersionState;
}

export const initialApplicationState: ApplicationState = {
  auth: { ...initialAuthState },
  user: { ...initialUserState },
  configVersion: { ...initialConfigVersionState },
  twoFactorAuth: { ...initialTwoFactorAuthState },
};

export const reducers: ActionReducerMap<ApplicationState> = {
  auth: auth.AuthReducer,
  user: user.UserReducer,
  configVersion: configVersion.ConfigVersionReducer,
  twoFactorAuth: twoFactorAuth.TwoFactorAuthReducer,
};

/**
 * metaReducer to clear application state on logouts
 */
export function clearState(reducer: ActionReducer<ApplicationState>): ActionReducer<ApplicationState> {
  return (state: ApplicationState, action: Action): ApplicationState => {
    if (action.type === LogoutAction.type) {
      state = {
        auth: { ...initialAuthState },
        user: { ...initialUserState },
        configVersion: { ...initialConfigVersionState },
        twoFactorAuth: { ...initialTwoFactorAuthState },
      };
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<ApplicationState>[] = [clearState];
